import React from "react";
import { connect } from "react-redux";
import RegisteredAnimalsTable from "../components/AnimalInventoryTable";
import { ANIMAL_TYPE_GOAT } from "variables/constants";

const Goats = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
	      	<RegisteredAnimalsTable animalTypeId={ANIMAL_TYPE_GOAT}/>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	filters: state.farmAnimal.recordList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  
});

export default connect(mapStateToProps, mapDispatchToProps)(Goats);
